import {
  EIconButtonSize,
  EIconButtonVariant,
  GeneralHelpIcon,
  IconButton,
  TPopoverTriggerProps,
} from '@outdoorsyco/bonfire';
import { forwardRef } from 'react';

import css from './AutoHelpButton.module.css';

export const AutoHelpButton = forwardRef<HTMLButtonElement, TPopoverTriggerProps>(
  ({ className: _className, ...props }, ref) => {
    return (
      <IconButton
        ref={ref}
        icon={GeneralHelpIcon}
        size={EIconButtonSize.Medium}
        variant={EIconButtonVariant.Secondary}
        className={css.helpButton}
        {...props}
      />
    );
  },
);

AutoHelpButton.displayName = 'AutoHelpButton';
